import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminFeedbacksPage, type AdminFeedbacksPageProps } from '../ui/admin/AdminFeedbacksPage';

export function AdminFeedbacksPageContainer(props: AdminFeedbacksPageProps) {
  return <AdminFeedbacksPage {...props} />;
}

export function mountAdminFeedbacksPage(
  container: HTMLElement,
  props: AdminFeedbacksPageProps
) {
  const root = createRoot(container);
  root.render(<AdminFeedbacksPageContainer {...props} />);
  return root;
}

export default AdminFeedbacksPageContainer;
